import React from 'react';
import styles from './StanTag.module.css';
import { StanTagProps } from '../types';
import { createIconElement } from '@/lib';
import { cn } from '@/lib/utils/cn';

export const StanTag: React.FC<StanTagProps> = ({
    label,
    imageString,
    svgAsset,
    className = '',
    style, // used for variable string colors
}) => {
    const BareIcon = svgAsset ? createIconElement(svgAsset, { className: styles.icon }) : null;

    return (
        // intentionally setting the color and background color to the neutral colors to override the css module
        <span className={cn(styles.tag, 'text-neutral-fg-primary-strong bg-neutral-subtle', className)} style={style}>
            {BareIcon}
            {imageString && <img src={imageString} alt='' className={styles.icon} />}
            {label}
        </span>
    );
};

export default StanTag;
